"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'myApps';
exports.FETCH_CONTENT = exports.namespace + "/FETCH_CONTENT";
exports.FETCH_RAIL = exports.namespace + "/FETCH_RAIL";
exports.SET_INSTALLED_APPS = exports.namespace + "/SET_INSTALLED_APPS";
exports.SET_FAVOURITE_APP = exports.namespace + "/SET_FAVOURITE_APP";
exports.REMOVE_FAVOURITE_APP = exports.namespace + "/REMOVE_FAVOURITE_APP";
exports.SET_LAST_OPENED_APP = exports.namespace + "/SET_LAST_OPENED_APP";
exports.FETCH_ALL_APPS = exports.namespace + "/FETCH_ALL_APPS";
//# sourceMappingURL=constants.js.map